import FunctionBarServLock from '@/presentation/pages/detail/basic/interface_lock/FunctionBarServLock';
export default class ClinicalFunctionBarService extends FunctionBarServLock {
}
